const topics = [
  { id: 1, label: '#顶流恋情曝光', heat: '982万', trend: 'up' },
  { id: 2, label: '#综艺录制翻车', heat: '756万', trend: 'up' },
  { id: 3, label: '#网红偷税被查', heat: '634万', trend: 'hot' },
  { id: 4, label: '#最新古装剧路透', heat: '521万', trend: 'up' },
  { id: 5, label: '#音乐节阵容官宣', heat: '489万', trend: 'new' },
  { id: 6, label: '#娱乐圈最新恋情', heat: '438万', trend: 'up' },
  { id: 7, label: '#明星婚变内幕', heat: '367万', trend: 'hot' },
  { id: 8, label: '#今日吃瓜合集', heat: '312万', trend: 'up' },
  { id: 9, label: '#饭圈互撕现场', heat: '256万', trend: 'down' },
  { id: 10, label: '#黑料独家曝光', heat: '198万', trend: 'hot' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">话题热榜</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            全网吃瓜话题热度实时排行，掌握最火的娱乐动态与黑料讨论方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-400">
                <i className={`text-[10px] ${topic.trend === 'hot' ? 'ri-fire-fill text-primary-500' : topic.trend === 'up' ? 'ri-arrow-up-fill text-accent-500' : topic.trend === 'new' ? 'ri-sparkling-fill text-secondary-500' : 'ri-arrow-down-fill text-foreground-400'}`}></i>
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}